module.exports = __webpack_public_path__ + "img/Picture1.5e07f80e.png";